import { render, staticRenderFns } from "./KpiTimeBeforeTaking.vue?vue&type=template&id=de20947a&"
import script from "./KpiTimeBeforeTaking.vue?vue&type=script&lang=js&"
export * from "./KpiTimeBeforeTaking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports